export const MODULES = {
  GEOCERCAS: "geocercas",
  PAUSAS: "pausas",
  CINTURONES: "cinturones",
};

export const hasModuleAccess = (userData, moduleKey) => {
  const empresaId = Number(userData?.empresaId || localStorage.getItem("empresaid") || 0);
  if (empresaId === 1) {
    return true;
  }

  if (moduleKey === MODULES.GEOCERCAS) {
    return userData?.moduloGeocercas !== false;
  }

  if (moduleKey === MODULES.PAUSAS) {
    return userData?.moduloPausas === true;
  }

  if (moduleKey === MODULES.CINTURONES) {
    return userData?.moduloCinturones === true;
  }

  return true;
};

export const isAdminCompany = (userData) => Number(userData?.empresaId || localStorage.getItem("empresaid") || 0) === 1;

export const getLandingPath = (userData) => {
  if (isAdminCompany(userData)) {
    return "/panel-administrador";
  }

  if (hasModuleAccess(userData, MODULES.GEOCERCAS)) {
    return "/rutas";
  }

  if (hasModuleAccess(userData, MODULES.PAUSAS)) {
    return "/pausas-activas";
  }

  if (hasModuleAccess(userData, MODULES.CINTURONES)) {
    return "/cinturones-seguridad";
  }

  return "/";
};
